import { render, staticRenderFns } from "./partner-index-edit.vue?vue&type=template&id=31f08248&"
import script from "./partner-index-edit.vue?vue&type=script&lang=js&"
export * from "./partner-index-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports